import * as GetMetricsTypes from 'src/actions/metrics/get/Types';
import Metrics from 'src/entities/Metrics';
import { GetMetricsAction, GetMetricsSuccess } from 'src/actions/metrics/get/GetMetrics.actions';

export interface GetMetricsState {
  metrics?: Metrics;
  loading: boolean;
  error: boolean;
  errorMessage: {};
}

const initialState: GetMetricsState = {
  loading: false,
  error: false,
  errorMessage: {}
};

export function GetMetricsReducer(state: GetMetricsState = initialState,
                                  action: GetMetricsAction): GetMetricsState {
  switch (action.type) {
    case GetMetricsTypes.GET_METRICS_ATTEMPT:
      return {...state, metrics: undefined, loading: true, error: false};
    case GetMetricsTypes.GET_METRICS_SUCCESS:
      const metrics: Metrics = (action as GetMetricsSuccess).payload;
      return {...state, metrics: metrics, loading: false, error: false};
    case GetMetricsTypes.GET_METRICS_FAILURE:
      return {
        ...state,
        metrics: undefined,
        loading: false,
        error: true,
        errorMessage: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/metrics/GetMetricsReducer.tsx